/* eslint-disable react/no-array-index-key */
import type { TooltipFormatterContextObject } from "highcharts";
import colors from "tailwindcss/colors";

interface PercentageSeriesTooltipProps {
  context: TooltipFormatterContextObject;
}
export default function PercentageSeriesTooltip({ context }: PercentageSeriesTooltipProps) {
  const percentageFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 1,
  });

  const valueFormatter = new Intl.NumberFormat("en", {
    notation: "compact",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  if (!context.points && context.point && context.key && typeof context.y === "number") {
    return (
      <div className="z-10 flex flex-col space-y-3 p-2 text-xs">
        <div className="grid auto-cols-auto grid-flow-col justify-between gap-x-4">
          <span className="font-mono font-semibold text-slate-600">{context.key}</span>
          <strong className="font-mono text-slate-700">{percentageFormatter.format(context.y / 100)}</strong>
        </div>
      </div>
    );
  }

  if (!context.x || typeof context.x !== "number" || !context.points) {
    return <span />;
  }

  const total = context.points
    .filter((node) => node.y)
    .reduce((total, node) => {
      if (!node.y) {
        return total;
      }

      return total + node.y;
    }, 0);

  return (
    <div className="z-10 flex flex-col space-y-3 p-2 text-xs">
      <span className="inline-flex justify-center rounded-lg bg-slate-50 px-2 py-1 font-mono text-sm font-bold text-slate-600">
        {context.key}
      </span>

      <ul className="space-y-1.5">
        {context.points.map((node, index) => {
          if (!node.y) {
            return null;
          }

          const textColor =
            node.series.userOptions && node.series.userOptions.type === "column"
              ? node.series.userOptions.borderColor || node.series.color
              : node.series.color;

          return (
            <li key={index} className="grid auto-cols-auto grid-flow-col justify-between gap-x-4">
              <span
                className="font-mono font-semibold"
                style={{
                  color: textColor && typeof textColor === "string" ? textColor : colors.slate[600],
                }}
              >
                {node.series.name}
              </span>
              <strong className="font-mono text-slate-700">{percentageFormatter.format(node.percentage / 100)}</strong>
            </li>
          );
        })}

        <li className="grid auto-cols-auto grid-flow-col justify-between gap-x-4">
          <span className="font-mono font-semibold">Votes</span>
          <strong className="font-mono text-slate-700">{valueFormatter.format(parseFloat(String(total)))}</strong>
        </li>
      </ul>
    </div>
  );
}
